// import Vue from 'vue'
import consts from "@/consts"
import range from "lodash/range";
import {arrayFilter_OnlyUnique, getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed__time';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

export default {
    state: {
        unitsFullLoad: false,
        unitsLiteLoad: false,
        units: {},
        unitEdit: null,
    },
    actions: {
        fetchUnits/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchUnits', args, time: Date.now() / 1000})

                let withRemoved = args?.without_removed ? {} : with_removed
                const params = getApiProps('units', args)
                this.$api.units.getAll({...params, ...withRemoved})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnits', args, inprogress: false})
                    });
            })
        },
        fetchUnitsAll({dispatch, commit}) {
            return new Promise((resolve, reject) => {
                this.$api.init.getUnits()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setUnits', response.data)
                            commit('setUnitsLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchUnitsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchUnitsAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isUnitsLiteLoad) {
                    return resolve(getters.getUnits.length)
                }
                dispatch('fetchUnits', {lite: true})
                    .then((data) => {
                        commit('updateUnits', data)
                        commit('setUnitsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchUnitsAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchUnitsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchUnitsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchUnitsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getUnits.length) {
                        return resolve([])
                    }

                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getUnits.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchUnits', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateUnits', data)
                            })
                            .catch(() => {
                                //dispatch('fetchUnits', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setUnitsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchUnitsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchUnitsChanged', args, inprogress: false})
                })
        },
        fetchUnitsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isUnitsFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchUnitsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchUnits', args)
                .then((data) => {
                    commit('updateUnits', data)
                    return dispatch('fetchUnits', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterUnits', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchUnitsChanged', args, inprogress: false})
                });
        },
        fetchFavoritesUnits({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchFavoritesUnits', args, time: Date.now() / 1000})

                dispatch('fetchUnits', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateUnits', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesUnits', args, inprogress: false})
                    });
            })
        },
        reloadUnitsAll({commit, dispatch}, args) {
            commit('clearUnitsMaxSpeed')
            return dispatch('fetchUnitsAllLite', args)
                .then(() => {
                    dispatch('fetchUnitsAllPages', args)
                })
        },

        fetchUnit({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchUnit', args, time: Date.now() / 1000})

                const params = getApiProps('units', args)
                delete params.id;
                this.$api.units.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && response.data) {
                            commit('updateUnit', response.data)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnit', args, inprogress: false})
                    });
            })
        },

        saveUnit({dispatch}, unit) {
            let fn = (unit.id) ? 'updateUnit' : 'createUnit'
            return dispatch(fn, unit);
        },
        createUnit({commit, dispatch}, unit) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('units')
                this.$api.units.create(unit, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUnit', response.data)
                            dispatch('fetchUnitsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateUnit({commit, dispatch}, unit) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('units')
                this.$api.units.update(unit.id, unit, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUnit', response.data)
                            dispatch('fetchUnitsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteUnit({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('units')
                this.$api.units.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteUnit', id)
                            else commit('updateUnit', response.data)
                            dispatch('fetchUnitsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreUnit({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('units')
                this.$api.units.restore(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUnit', response.data)
                            dispatch('fetchUnitsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteUnitPermanently({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('units')
                this.$api.units.deletePermanently(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteUnit', id)
                            dispatch('fetchUnitsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        fetchUnitExtServices({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchUnitExtServices', args, time: Date.now() / 1000})

                let params = getApiProps('unit_ext_services', args)
                delete params.unitId;
                this.$api.units.find(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && response.data) {
                            commit('updateUnit', response.data)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitExtServices', args, inprogress: false})
                    });
            })
        },
        fetchUnitProps({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId || !args.action) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchUnitProps.'+args.action, args, time: Date.now() / 1000})

                let props = {...args}; delete props.unitId; delete props.action;
                this.$api.units.getProps(args.unitId, args.action, props)
                    .then((response) => {
                        if (response.status < 400 && response.data) {
                            //
                        }
                        resolve(response.data)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitProps.'+args.action, args, inprogress: false})
                    });
            })
        },

    },
    mutations: {
        setUnitsFullLoad(state, FullLoad) {
            state.unitsFullLoad = state.unitsFullLoad || FullLoad
        },
        setUnitsLiteLoad(state, LitaLoad) {
            state.unitsLiteLoad = state.unitsLiteLoad || LitaLoad
        },

        setUnits(state, nUnits) {
            nUnits = nUnits.map(u => {
                if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                if (u?.hw_type) u.hw_type_ = u.hw_type.toLocaleLowerCase()
                if (u?.hw_id) u.hw_id_ = u.hw_id.toLocaleLowerCase()
                if (u?.camera_type) u.camera_type_ = u.camera_type.toLocaleLowerCase()
                if (u?.camera_id) u.camera_id_ = u.camera_id.toLocaleLowerCase()

                return u //Object.freeze(u)
            })
            //nUnits.sort(sortByName)
            state.units = nUnits.reduce((unitsByIds, unit) => {
                unitsByIds[unit.id] = unit
                return unitsByIds
            }, {})
        },

        updateUnits(state, nUnits) {
            if (!Object.keys(state.units).length) {
                nUnits = nUnits.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    if (u?.hw_type) u.hw_type_ = u.hw_type.toLocaleLowerCase()
                    if (u?.hw_id) u.hw_id_ = u.hw_id.toLocaleLowerCase()
                    if (u?.camera_type) u.camera_type_ = u.camera_type.toLocaleLowerCase()
                    if (u?.camera_id) u.camera_id_ = u.camera_id.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                // nUnits.sort(sortByName)
                state.units = nUnits.reduce((unitsByIds, unit) => {
                    unitsByIds[unit.id] = unit
                    return unitsByIds
                }, {})
                return true
            }

            nUnits.forEach((nUnit) => {
                if (nUnit?.name) nUnit.name_ = nUnit.name.toLocaleLowerCase()
                if (nUnit?.hw_type) nUnit.hw_type_ = nUnit.hw_type.toLocaleLowerCase()
                if (nUnit?.hw_id) nUnit.hw_id_ = nUnit.hw_id.toLocaleLowerCase()
                if (nUnit?.camera_type) nUnit.camera_type_ = nUnit.camera_type.toLocaleLowerCase()
                if (nUnit?.camera_id) nUnit.camera_id_ = nUnit.camera_id.toLocaleLowerCase()
                let unit = state.units[nUnit.id]
                if (!unit) {
                    state.units[nUnit.id] = (nUnit) //(Object.freeze(nUnit))
                } else
                if (!state.unitsFullLoad || (unit[changedField] != nUnit[changedField] && unit[changedField]>0)) {
                    updateObjectByDiff(unit, nUnit)
                    // delete nUnit.id
                    // nUnit = {...unit, ...nUnit}
                    // unit = nUnit //Object.freeze(nUnit)
                }
            })

        },
        filterUnits(state, nUnits) {
            // let Ids = state.units.map(u=> u.id)
            let nIds = nUnits.map(u => u.id)
            let removedIds = Object.keys(state.units).filter(uid => !nIds.find(nId => nId == uid))
            removedIds.forEach(removedId => {
                delete state.units[removedId]
            })
        },
        updateUnit(state, nUnit) {
            if (nUnit?.name) nUnit.name_ = nUnit.name.toLocaleLowerCase()
            if (nUnit?.hw_type) nUnit.hw_type_ = nUnit.hw_type.toLocaleLowerCase()
            if (nUnit?.hw_id) nUnit.hw_id_ = nUnit.hw_id.toLocaleLowerCase()
            if (nUnit?.camera_type) nUnit.camera_type_ = nUnit.camera_type.toLocaleLowerCase()
            if (nUnit?.camera_id) nUnit.camera_id_ = nUnit.camera_id.toLocaleLowerCase()

            let unit = state.units[nUnit.id]
            if (!unit) {
                state.units[nUnit.id] = (nUnit) //(Object.freeze(nUnit))
            } else
            if (!state.unitsFullLoad || (unit[changedField] != nUnit[changedField])) { // && unit[changedField]>0
                updateObjectByDiff(unit, nUnit)
                // delete nUnit.id
                // nUnit = {...unit, ...nUnit}
                // unit = nUnit //Object.freeze(nUnit)
            }
        },
        setUnitEdit(state, unit) {
            state.unitEdit = unit
        },
        deleteUnit(state, id) {
            delete state.units[id]
        },

        clearUnits(state) {
            state.units = {}
            state.unitsFullLoad = false
        },
        clearUnitsMaxSpeed(state) {
            Object.keys(state.units).forEach(uId => {
                state.units[uId].max_speed = null
                state.units[uId][changedField] = 0
            })
        },
    },
    getters: {
        isUnitsFullLoad(state) {
            return state.unitsFullLoad
        },
        isUnitsLiteLoad(state) {
            return state.unitsLiteLoad
        },
        getUnitsOutputsById(state, getters) {
            return Object.keys(state.units).reduce((out, uId) => {
                let lmsg = getters.getUnitsLmsgsByIds[uId]
                let outputs = state.units[uId]?.outputs || [];
                out[uId] = outputs.map(o => {
                    let sensor = (lmsg?.sensors || {})[o.param] || {}
                    let value = sensor.value
                    return {
                        name: o.name,
                        view: o.name > '' && o.param > '',
                        // value: value,
                        value: (value === null || value === undefined) ? 'null' : (value ? 'on' : 'off'),
                    }
                })
                return out
            }, {})
        },
        getUnitsInputsById(state, getters) {
            return Object.keys(state.units).reduce((out, uId) => {
                let lmsg = getters.getUnitsLmsgsByIds[uId]
                let inputs = state.units[uId]?.inputs || [];
                out[uId] = inputs.map(i => {
                    let sensor = (lmsg?.sensors || {})[i.param] || {}
                    let value = sensor.value
                    return {
                        name: i.name,
                        view: i.name > '' && i.param > '',
                        // value: value,
                        value: (value === null || value === undefined) ? 'null' : (value ? 'on' : 'off'),
                    }
                })
                return out
            }, {})
        },

        getUnits(state) {
            return Object.values(state.units)
        },
        getFirstActivatedUnitId(_, getters) {
            return getters.getSortedUnitsIds[0] || 0
        },
        getUnitsByIds(state) {
            return state.units
        },
        getUnitsIdsIsFullLoad(state) {
            return Object.values(state.units)
                .filter(u => (typeof u[changedField] !== 'undefined'))
                .map(u => u.id)
        },
        getUnitsFullLoadByIds(state) {
            return Object.values(state.units)
                .reduce((unitsByIds, unit) => {
                    unitsByIds[unit.id] = (typeof unit[changedField] !== 'undefined')
                    return unitsByIds
                }, {})
        },
        getUnitsAccessRightsByIds(state) {
            return Object.values(state.units)
                .reduce((unitsAccessRightsByIds, unit) => {
                    unitsAccessRightsByIds[unit.id] = unit?.access_right || 0
                    return unitsAccessRightsByIds
                }, {})
        },
        getSortedUnitsIds(state) {
            let units = Object.values(state.units)
            units.sort(sortByName)
            return units.map(u => u.id)
        },
        getLockedUnits(state) {
            return Object.values(state.units).filter(u => u[changedField] < 0).map(u => u.id)
        },
        getUnitsHasVideo(state) {
            return Object.values(state.units).filter(u => !!u.video).map(u => u.id)
        },
        getUnitsCameraTypes(state) {
            return Object.values(state.units).filter(u => u.video?.cameratype).map(u => u.video?.cameratype).filter(arrayFilter_OnlyUnique)
        },
        getSubUnitsIdsByIds(state) {
            return Object.values(state.units).filter(u => u.parent__id)
                .reduce((unitsIdsBy, u) => {
                    let parentId = u.parent__id || ''
                    if(!unitsIdsBy[parentId]){
                        unitsIdsBy[parentId] = []
                    }
                    unitsIdsBy[parentId].push(u.id)
                    return unitsIdsBy
                }, {'': []})
        },
        getUnitsIdsByCameraTypes(state) {
            return Object.values(state.units).filter(u => u.video?.cameratype)
                .reduce((unitsIdsBy, u) => {
                    if(!unitsIdsBy[u.video?.cameratype]){
                        unitsIdsBy[u.video?.cameratype] = []
                    }
                    unitsIdsBy[u.video?.cameratype].push(u.id)
                    return unitsIdsBy
                }, {})
        },
        getUnitsIdsByHwTypes(state) {
            return Object.values(state.units)
                .reduce((unitsIdsBy, u) => {
                    if(!unitsIdsBy[u.hw_type]){
                        unitsIdsBy[u.hw_type] = []
                    }
                    unitsIdsBy[u.hw_type].push(u.id)
                    return unitsIdsBy
                }, {})
        },
        getUnitsByParentId(state) {
            return Object.values(state.units)
                .filter(u => u.parent__id)
                .reduce((out, u) => {
                    if(!out[u.parent__id]) out[u.parent__id] = []
                    out[u.parent__id].push(u.id)
                    return out;
                }, {})
        },
    }
}
